import { gql } from 'urql';

const GetLineOfCreditAutoPayStatus = gql`
  query GetLineOfCreditDetailsResult {
    getLineOfCreditDetailsResult {
      isAutopayEnabled
    }
  }
`;

export default GetLineOfCreditAutoPayStatus;
